/**
 * Finds the smile center an appointment belongs to.
 *
 * A center can host merged calendars (`mergeCalendars`), each one with its own
 * calendar id and appointment type id. An appointment booked on a merged
 * calendar never matches the center's own `Calendar_Id`, so the lookup returns
 * nothing and the UI ends up rendering "Centro: undefined" with no address and
 * no map.
 *
 * Only the calendar lookup walks `mergeCalendars`. Calendar ids are unique
 * across the centers `/get-centers` returns, but an appointment type id is not:
 * a center can use as its main type the same id another center hosts as a
 * merged one, so widening the appointment type lookup could resolve to the
 * wrong center.
 *
 * Both sides of the calendar comparison are coerced with `toString()`. The code
 * this replaces coerced only the center's side, so a patient whose
 * `Calendar_Id` arrived as a number matched no center at all; that case now
 * resolves too.
 *
 * @param {Array} branches Smile centers as returned by /get-centers
 * @param {String} calendarId Calendar the appointment lives on
 * @param {String} appointmentTypeId Appointment type, used when there is no calendar id
 * @returns {Object|undefined} The matching smile center
 */
const findBranchByAppointment = (branches, calendarId, appointmentTypeId) => {
  if (!Array.isArray(branches)) return undefined

  if (calendarId) {
    return branches.find((branch) => {
      if (branch.Calendar_Id && branch.Calendar_Id.toString() === calendarId.toString()) return true
      return (branch.mergeCalendars || []).some(
        (merged) => merged.calendarId && merged.calendarId.toString() === calendarId.toString()
      )
    })
  }

  return branches.find(
    (branch) => branch.Appointment_Type_Id
      && branch.Appointment_Type_Id.toString() === appointmentTypeId
  )
}

export default findBranchByAppointment
